import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import slugify from 'slugify';
import styled from 'react-emotion';
import Page from 'structure/page';
import {
  getProducts,
  getProductPreviewImageUrl,
  getProductPriceString
} from 'service/products';
import { PRODUCT_MORE_DETAILS, PRODUCT_IMAGE_CLICK } from 'util/events';
import log from 'util/log';

const ProductCardLayout = styled('div')({
  clear: 'both',
  borderBottom: 'dashed 1px grey',
  minHeight: '155px',
  margin: '3px 0',
  padding: '3px 0',
});

const ProductImage = styled('img')({
  float: 'left',
  borderRadius: '10px',
  marginTop: '0.2em',
  marginRight: '10px',
  marginBottom: '0.5em',
  marginLeft: 0,
  width: '120px',
  height: '150px',
});

const ProductTitle = styled('h3')({
  marginTop: 0,
  marginBottom: 0,
}, ({ theme }) => ({
  ...theme.typography.heading,
}));

const ProductLink = ({ product, children, onClick, className }) => (
  <Link className={className} onClick={onClick} to={`/store/${slugify(product.name, { lower: true })}-${product.id}`}>{children}</Link>
);

const MoreDetailsLink = styled(ProductLink)({
  whiteSpace: 'nowrap',
});

const ProductCard = ({ product, onImageClick, onMoreDetailsClick }) => (
  <ProductCardLayout>
    <ProductLink product={product} onClick={onImageClick}>
      <ProductImage
        src={getProductPreviewImageUrl(product, 'preview')}
      />
    </ProductLink>
    <ProductTitle>{product.name}</ProductTitle>
    <p>{getProductPriceString(product)} <MoreDetailsLink onClick={onMoreDetailsClick} product={product}>More Details</MoreDetailsLink></p>
    <p>{product.description}</p>
  </ProductCardLayout>
);

export class Store extends Component {
  constructor(args) {
    log.info("Store: constructor");
    super(args);
    this.state = { };
  }

  componentDidMount() {
    log.info("Store: componentDidMount");
    getProducts()
      .then(products => {
        log.info("Store: Resolved in componentDidMount");
        this.setState({ products });
      });
  }

  render() {
    log.info("Store: render");
    return (
      <Page title="Our Corsets" {...this.props}>
        <p>Choose from one of our corset designs below, and customize with your measurements
        and choice of fabrics, or contact us to <Link to="/commission/">commission</Link> a truly personal corset.
        </p>

        {this.state.products ?
          this.state.products.map(product => (
          <ProductCard
            key={product.id}
            product={product}
            onImageClick={() => this.props.onEvent(PRODUCT_IMAGE_CLICK(product))}
            onMoreDetailsClick={() => this.props.onEvent(PRODUCT_MORE_DETAILS(product))}
          />
        )) : <p>Loading...</p>}
      </Page>
    );
  }
}

export default Store;



// WEBPACK FOOTER //
// ./src/pages/store/store.js